interface ElectronicSignatureConsentProps {
    checked?: boolean;
    onChange?: (checked: boolean) => void;
    hasError?: boolean;
}

const ElectronicSignatureConsent = ({ checked = false, onChange, hasError = false }: ElectronicSignatureConsentProps) => {
    return (
        <form data-testid="electronic-signature-consent-form" onSubmit={(e) => e.preventDefault()}>
            <div className="flex items-center gap-4 w-[370px] h-[40px] tablet:w-[448px] tablet:h-[56px]">
                <input
                    type="checkbox"
                    name="electronicSignatureConsent"
                    id="electronicSignatureConsent"
                    className={`checkbox checkbox-md flex-shrink-0 ${hasError ? "checkbox-error" : ""}`}
                    checked={checked}
                    onChange={(e) => onChange?.(e.target.checked)}
                    data-testid="electronic-signature-consent-checkbox"
                    aria-describedby="agreement-fraud-warning agreement-electronic-signature"
                />
                <label
                    htmlFor="electronicSignatureConsent"
                    className="leading-5 text-sm text-base-content font-semibold"
                    data-testid="electronic-signature-consent-label"
                >
                    I understand the Fraud Warning and agree to the Consent for Electronic Signature.
                </label>
            </div>
            {hasError && (
                <div
                    className="bg-warning border border-warning rounded-lg p-4 mt-2"
                    data-testid="electronic-signature-consent-error"
                >
                    <p className="text-warning-content font-medium text-sm leading-5">You must agree before continuing</p>
                </div>
            )}
        </form>
    );
};

export default ElectronicSignatureConsent;
